import React, { useState } from "react";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../../../../shared/Button/Button";
import { ConfirmModal } from "../../../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { useDelete } from "../../../../../hooks/useDelete";
import { useContext } from "../../../../../context";

export const Delete = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { 0: isConfirmOpen, 1: setIsConfirmOpen } = useState(false);
  const del = useDelete();
  const { isError } = useContext();

  return (
    <>
      <Button
        size="small"
        color="error"
        onClick={() => setIsConfirmOpen(true)}
        isDisabled={isError}
      >
        {t("action.delete")}
      </Button>
      {isConfirmOpen && (
        <ConfirmModal
          isOpen
          isConfirming={del.isLoading}
          onClose={() => setIsConfirmOpen(false)}
          onCancel={() => setIsConfirmOpen(false)}
          onConfirm={() => del.initiate().then(() => setIsConfirmOpen(false))}
        >
          {t("confirm.delete")}
        </ConfirmModal>
      )}
    </>
  );
};
